<script lang="ts">
  import {createEventDispatcher} from 'svelte';
  import {envUtil} from '@/helper/env';
  import {referral$} from '@/store/referral';
  import GoogleLogin from '@/modules/components/access-google/AccessWithGoogle.svelte';
  import AppleLogin from '@/modules/components/access-apple/AccessWithApple.svelte';
  import AccessWithTelegram from '@/modules/components/access-telegram/AccessWithTelegram.svelte';
  import AccessWithTwitter from '@/modules/components/access-twitter/AccessWithTwitter.svelte';
  import WalletEntry from './wallet/Wallet.svelte';

  let className = '';
  export {className as class};

  export let entrance: string = '';
  export let scene: string = '';
  export let target: string = null;
  export let referralCode: string = '';
  export let fromType: string = null;
  export let isOauth: boolean = false;
  export let loginType: string = '';

  export let lang = {};

  const dispatch = createEventDispatcher();
  let metaMaskDom, walletConnectDom;
  $: group = $referral$ && $referral$.group;

  function handleClose(){
    dispatch('close')
  }
</script>

<style lang="scss">
  .third-login :global(.modal-mask),
  .third-login :global(.container){
    z-index: 1000000;
  }
  @media screen and (max-width: 640px) {
    .third-login.jcc{
      gap: 24px;
    }
    .third-login.jcc :global(.wallet-connect-box){
      width: 48px;
    }
  }
</style>

<div class="df aic third-login" class:jcsb={!envUtil.isMobile} class:jcc={envUtil.isMobile}>
    <GoogleLogin {loginType} {scene} {referralCode} {group} {isOauth} {lang} on:close={handleClose}/>
    <AppleLogin {target} {scene} {referralCode} {group}/>
    <AccessWithTelegram {target} {scene} {referralCode} {group}/>
    <AccessWithTwitter {target} {entrance} next='login'/>
  {#if !envUtil.isMobile}
    <WalletEntry class="f1" walletProps={{scene, referralCode, fromType, isOauth, group}}/>
  {/if}

</div>
{#if envUtil.isMobile}
  <div class="df aic jcc mt12">
    <WalletEntry walletProps={{scene, referralCode, fromType, isOauth, group}}/>
  </div>
{/if}
